export const Default = {
    /**
     * Default size used.
     *
     * @var  {string}
     */
    size: 'normal-font',

    /**
     * Default size configuration.
     *
     * @var  {object}
     */
    fontSize: {
        'normal-font': true,
        'big-font':    false,
        'giant-font':  false
    },

    /**
     * Animations activated.
     *
     * @var  {bool}
     */
    animationsToggle: true,

    /**
     * Open dyslexic font settings.
     *
     * @var  {bool}
     */
    openDyslexicToggle: false,

    /**
     * Categories data.
     *
     * @var {string}   hexadecimal
     */
    categories: {
        pib: {
            color:      '#c0c400',
            icon:       'pib-black@2x.png'
        },
        immigration:{
            color:      '#f4d466',
            icon:       'immigration-black@2x.png'
        },
        analyse:{
            color:      '#34c2fa',
            icon:       'analyse-black@2x.png'
        },
        exchange:{
            color:      '#faa28e',
            icon:       'exchange-black@2x.png'
        }
    }
};
